import { createOption } from '../helpers/selectHelpers';

const selectSizeOptions = [
    // createOption('1024x768', '1024x768'),
    createOption('970x250 (Billboard)', '970x250'),
    createOption('970x90', '970x90'),
    // createOption('768x1024'),
    createOption('728x90 (Leaderboard)', '728x90'),
    createOption('640x480', '640x480'), // Video / VAST
    createOption('640x640', '640x640'), // Audio / VAST
    createOption('480x320', '480x320'),
    // createOption('468x60 (Banner)', '468x60'),
    createOption('400x300', '400x300'), // Video / VAST
    createOption('336x280', '336x280'),
    // createOption('320x480', '320x480'),
    createOption('320x100 (Large Mobile Banner)', '320x100'),
    createOption('320x50 (Mobile Banner)', '320x50'),
    createOption('300x600 (Half Page)', '300x600'),
    createOption('300x250 (Medium Rectangle)', '300x250'),
    createOption('300x100', '300x100'),
    createOption('300x50', '300x50'),
    // createOption('250x250 (Square)', '250x250'),
    // createOption('234x60', '234x60'),
    // createOption('200x200', '200x200'),
    // createOption('180x150', '180x150'),
    createOption('160x600 (Wide Skyscraper)', '160x600'),
    // createOption('125x125', '125x125'),
    createOption('120x600 (Skyscraper)', '120x600'),
    createOption('fluid', 'fluid'),
    // createOption('120x240', '120x240'),
    // createOption('120x90', '120x90'),
    // createOption('88x31', '88x31'),
];

export default selectSizeOptions;